import { filter, isEmpty, get } from "lodash";
import {
  useWorkspace,
  useWorkspaceTagConfig,
} from "src/contexts/global/WorkspaceContext";
import { isTagTypeReadOnly } from "src/util/tags";
import { useAuth0 } from "src/contexts/auth0Provider";

const useShowTagsEditor = (tags) => {
  const { user } = useAuth0();
  const workspace = useWorkspace();
  const tagConfig = useWorkspaceTagConfig();

  const personTagTypes = get(workspace, "config.tagTypes.person", []);
  const readOnlyTagTypes = filter(personTagTypes, (tagType) =>
    isTagTypeReadOnly({ tagType, tagConfig, user })
  );

  const isAllTagTypesReadOnly =
    readOnlyTagTypes.length === personTagTypes.length;

  return {
    showTagsEditor: !isEmpty(tags) && !isAllTagTypesReadOnly,
    isAllTagTypesReadOnly,
  };
};

export default useShowTagsEditor;
